// Presence-mode poll cadence: used only while a customer record row is expanded
// (no drawer/modal open) — light enough to tolerate several rows expanded at once.
export const PRESENCE_INTERVAL_MS = 30000;

// Detail-mode poll cadence: used only while the renewal status modal is open.
// Values carried over unchanged from the original inline RenewalStatusSection.
export const DETAIL_FAST_INTERVAL_MS = 5000;
export const DETAIL_SLOW_INTERVAL_MS = 20000;
export const DETAIL_FAST_PHASE_DURATION_MS = 60000;

// Hard cap on how long either polling mode will keep retrying before giving up
// and surfacing a manual "Refresh status" affordance instead.
export const MAX_POLLING_DURATION_MS = 30 * 60 * 1000;

// Deadline for a single status request. Without this, a request that never settles
// (e.g. a hung connection) would leave that account's poller stuck "in flight" forever,
// blocking all further polling for it.
export const REQUEST_TIMEOUT_MS = 15000;

// Debounce before starting a presence-mode subscription, so scanning/scrolling
// through a list of rows doesn't fire a GET per row per click.
export const EXPAND_DEBOUNCE_MS = 400;

// Tick interval for the modal's live "updated Xs ago" freshness label.
export const FRESHNESS_TICK_MS = 1000;

// How long the "Trigger Auto Renewal" button stays disabled after a successful
// trigger. This only gates re-triggering — it is not a proxy for whether a
// renewal is actually still in flight (the pill/modal's polled status is).
export const COOLDOWN_SECONDS = 120;
